import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { IntentProjectResourcesSuggestions } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

import useCellFilterAction from "../useCellFilterAction";

const IntentProjectsTableSpaceCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const spaceUrl = `/spaces/${intentProject.space.id}`;

  const spaceFilterAction = useCellFilterAction({
    filterName: IntentProjectResourcesSuggestions.SPACE,
    filterValue: intentProject.space.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellSpace href={spaceUrl}>{intentProject.space.name}</TableCellSpace>
    </TableSimpleCell>
  );
};

export default IntentProjectsTableSpaceCell;
